import React, { Fragment } from 'react'
import { DrilldownAttackEvent } from '../drilldown-content-view'
import { MustacheChapterView } from './mustache-chapter-view'

export function AttackEventRequest({
  attackEvent: { requestChapters }
}: {
  readonly attackEvent: DrilldownAttackEvent
}) {
  return (
    <Fragment>
      {requestChapters &&
        requestChapters.map((chapter, i) => (
          <MustacheChapterView key={i} chapter={chapter} />
        ))}
    </Fragment>
  )
}
